<template>
    <div class="common_container">
        <el-form :model="ruleForm" :rules='rules' ref="ruleForm" v-loading='loading' label-width="80px">

            <!-- 目录名称 上级目录 -->
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="目录名称" prop='title'>
                        <el-input v-model="ruleForm.title" class="form-input"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="上级目录">
                        <el-cascader
                            ref='parentMenu'
                            :props="parentNumberService"
                            clearable
                            v-model="ruleForm.parentNumberService"
                            :show-all-levels="false"
                            class="form-input">
                            <template slot-scope="{ node, data }">
                                <span>{{ data.label }}</span>
                            </template>
                        </el-cascader>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 关联公司 服务分支 -->
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="关联公司" prop='companys'>
                        <el-select v-model="ruleForm.companys" placeholder="请选择" class="form-input">
                            <el-option
                            v-for="item in companyData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="服务分值" prop='serviceShare'>
                        <el-input v-model="ruleForm.serviceShare" class="form-input" type='number' min='0'/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" >
                    <el-form-item>
                        <el-button type="primary" size="small" @click="submitForm('ruleForm')" :disabled="isSubmit">{{ type == 'edit' ? '修改' : '创建' }}</el-button>
                        <el-button type="default" size="small" @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import services from '../serve.services'

import commonService from "../../../services/common.service"

import { catalogRules } from '../serve.rules'

const rules = catalogRules()
export default {

    props:{
        type:{
            type:String,
            default:"add"
        },
        // parentNumber:String,
        form:Object,
        parentNumber: String,
        callback: Function
    },

    data() {
        return {
            ruleForm: {
                parentNumberService: [],
                title: '',
                company: '',
                serviceShare: ''
            },
            rules,
            parentNumberService: {
                lazy: true,
                checkStrictly: true,
                lazyLoad: (node, resolve) => this.lazyLoad(node, resolve)
            },
            loading: true,
            companyData: [],
            isSubmit:false
        }
    },

    mounted() {
        services.companyList()
            .then(res => this.companyData = res.list)
            .catch(err => this.$message.error(err.message))

        if(this.type === 'edit') {
            // console.log(this.$refs.parentMenu.$el.children[0].children[0]);
            // console.log(this.form);
            // console.log(this.form.parentNumber);
            this.$refs.parentMenu.$el.children[0].children[0].value = this.form.parentNumber && this.form.parentNumber.title || ''
        }
    },

    created() {
        if(this.type == 'edit'){
            this.$modal.title = "修改服务";
            this.ruleForm = {
                ...this.form,
                companys: this.form.company.title
            }
        }
        if (this.parentNumber) {
            this.$modal.title='提交为服务'
            this.getDetails()
        }
        this.loading = false
    },

    methods: {

        // 提交时详情默认显示
        getDetails(){
            commonService.getCorrectDetail({ serialNumber:this.parentNumber}).then(res => {
                this.ruleForm = res;
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                this.loading = false;
            })
        },

        // 上级目录请求数据
        lazyLoad (node, resolve) {
            services.serviceList( node.level !== 0 && {parentNumber: node.value}).then(res => {
                let newArr = res.list.map(item => {
                    return {
                        value: item.serialNumber,
                        label: item.title,
                        leaf: !item.hasChildren
                    }
                })
                resolve(newArr)
            })
        },

        // 确认提交按钮
        submitForm(formName) {
            this.isSubmit=true
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.type === 'add') {
                        this.request({ request: services.serviceAdd, params: this.setParams() })
                    } else if (this.type === 'edit') {
                        let params = this.setParams()
                        if(params.parentNumberService) {
                            this.request({ request: services.serviceEdit, params })
                        } else {
                            params.parentNumberService
                                = this.ruleForm.parentNumberService
                                ? this.ruleForm.parentNumberService.number
                                : params.parentNumberService
                            this.request({ request: services.serviceEdit, params })
                        }
                    }
                } else {
                    this.isSubmit=false
                    this.$message.error('✳为必填项，请全部填写')
                }
            });
        },

        // 设置请求数据
        setParams() {
            return {
                serialNumber: this.form && this.form.serialNumber,
                mainCase: this.parentNumber && this.parentNumber,
                title: this.ruleForm.title,
                serviceShare: this.ruleForm.serviceShare,
                company: this.form && this.form.company.id || this.ruleForm.companys,
                parentNumberService: Array.isArray(this.ruleForm.parentNumberService) ? this.ruleForm.parentNumberService.pop() : '',
            }
        },

        // 重置
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },

        // 发起请求
        request({ request, params }) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            request(params)
                .then( res => this.$message.success(`${this.type === 'edit' ? '编辑' : '创建'}成功`))
                .catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message)
                    }
                ).finally(() => {
                        loading.close()
                        this.$modal.close()
                        this.callback();
                })
        }
    }
}
</script>

<style lang="scss" scoped>
    .el-form-item {
        img {
            vertical-align: middle;
            margin-left: 5px;
        }
    }
</style>

